import * as french from './french.json';
import * as sidebarmenu from './sidebarmenu.json';
const allFr = {
  french,
  sidebarmenu
};

export default allFr;
